import { HeartMultipleOutlineIcon } from './HeartMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A4672312-BF75-4CE0-88FF-C7D3BC724AA0
 * name heart-multiple-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-multiple-outline.svg
 * tags
 */
export const HeartsOutlineIcon = HeartMultipleOutlineIcon;
export default HeartsOutlineIcon